import { render, staticRenderFns } from "./travel-insurance-additional-traveller-card.vue?vue&type=template&id=0e32a1b6&scoped=true"
import script from "./travel-insurance-additional-traveller-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-insurance-additional-traveller-card.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-insurance-additional-traveller-card.vue?vue&type=style&index=0&id=0e32a1b6&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e32a1b6",
  null
  
)

export default component.exports